import { render, staticRenderFns } from "./NewsPublic.vue?vue&type=template&id=cd9f9332&scoped=true&"
import script from "./NewsPublic.vue?vue&type=script&lang=js&"
export * from "./NewsPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9f9332",
  null
  
)

export default component.exports